/**
 * Pure selection logic for the "What's New" feed.
 * `now` is injectable so the 30-day window is deterministically testable.
 */
import { ProductUpdate } from '@/types';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

/** Unread published updates whose publish date is within the last 30 days, newest first. */
export function selectAutoOpenUpdates(
  updates: ProductUpdate[],
  readIds: Set<string>,
  now: number,
): ProductUpdate[] {
  return updates
    .filter((u) => {
      if (readIds.has(u.id) || !u.publishedAt) return false;
      const age = now - new Date(u.publishedAt).getTime();
      return age >= 0 && age <= THIRTY_DAYS_MS;
    })
    .sort((a, b) => new Date(b.publishedAt!).getTime() - new Date(a.publishedAt!).getTime());
}

/** Count of unread updates (all-time) — drives the bell badge. */
export function unreadCount(updates: ProductUpdate[], readIds: Set<string>): number {
  return updates.reduce((n, u) => (readIds.has(u.id) ? n : n + 1), 0);
}
